export default __webpack_public_path__ + "static/media/live_classes.8a9baa97.png";